import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import Link from 'next/link';

import Button from '@gjc/classi-react-commons/ClassiButton';
import { TextButton } from 'styles/theme-styled';
import {
    BotaoVerTelefoneTexto,
    TelefoneContainer,
    TelefoneEscondidoContainer,
    TelefoneEscondidoTexto,
    WhatsappButtonContainer,
} from './telefoneEscondido-styled';

const TelefoneEscondido = ({
    telefone,
    whatsappUrl,
}) => {
    // Criando um objeto de telefones com um valor de isMaskEnabled setado para true
    const objTelefones = telefone?.map(function (value) {
        return { tel: value, isMaskEnabled: true };
    });

    const [telefones, setTelefones] = useState(objTelefones);

    const updateTelefoneObjState = (index) => {
        telefones[index].isMaskEnabled = false;
        setTelefones([...telefones]);
    };

    return (
        <>
            {telefones?.map((item, index) => (
                <TelefoneContainer key={index}>
                    <TelefoneEscondidoContainer>
                        <TelefoneEscondidoTexto
                            isMaskEnabled={telefones[index].isMaskEnabled}
                            onClick={() => {
                                updateTelefoneObjState(index);
                            }}
                            className="ver_telefone"
                        >
                            {item.tel}
                        </TelefoneEscondidoTexto>
                    </TelefoneEscondidoContainer>
                    {telefones[index].isMaskEnabled ? (
                        <TextButton
                            className="ver_telefone"
                            onClick={() => {
                                updateTelefoneObjState(index);
                            }}
                        >
                            <BotaoVerTelefoneTexto>
                                Ver telefone
                            </BotaoVerTelefoneTexto>
                        </TextButton>
                    ) : (
                        <>
                            {isMobile && (
                                <Link href={`tel:+55${item.tel}`} passHref>
                                    <Button
                                        appearance={'primary'}
                                        label={'Clique para ligar'}
                                        fontSize={14}
                                        height={'30px'}
                                        style={{
                                            marginLeft: 0,
                                            marginRight: 0,
                                            backgroundColor: '#ffa000',
                                            border: 'none',
                                            width: '130px',
                                        }}
                                    />
                                </Link>
                            )}
                        </>
                    )}
                </TelefoneContainer>
            ))}
            {whatsappUrl && (
                <WhatsappButtonContainer length={telefones.length}>
                    <a
                        href={whatsappUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="whatsapp"
                    >
                        <Button
                            appearance={'primary'}
                            label={'Contato via WhatsApp'}
                            style={{
                                marginLeft: 0,
                                marginRight: 0,
                                backgroundColor: '#25d366',
                                border: 'none',
                                alignSelf: 'end',
                                verticalAlign: 'top',
                                width: '100%',
                            }}
                        />
                    </a>
                </WhatsappButtonContainer>
            )}
        </>
    );
};

export default TelefoneEscondido;
